import React from 'react';
import { FadeIn } from './FadeIn';
import { BrainCircuit, Scale, Eye, ShieldAlert, Target, Clock, Network, Award } from 'lucide-react';
const features = [{
  icon: BrainCircuit,
  title: 'Consequential Thinking',
  desc: 'Ability to map second and third-order effects of policy decisions.'
}, {
  icon: Scale,
  title: 'Emotional Regulation',
  desc: 'Maintaining objective analysis under stress and ideological pressure.'
}, {
  icon: Eye,
  title: 'Reality Testing',
  desc: 'Capacity to update beliefs based on empirical evidence and falsification.'
}, {
  icon: ShieldAlert,
  title: 'Manipulation Resistance',
  desc: 'Immunity to demagoguery, propaganda, and tribal heuristics.'
}, {
  icon: Target,
  title: 'Executive Discipline',
  desc: 'Focusing on structural execution rather than performative signaling.'
}, {
  icon: Clock,
  title: 'Long-Term Planning',
  desc: 'Prioritizing intergenerational stability over short-term gratification.'
}, {
  icon: Network,
  title: 'Social Cooperation',
  desc: 'Navigating complex institutional dynamics without zero-sum thinking.'
}, {
  icon: Award,
  title: 'Leadership Responsibility',
  desc: 'Accepting the burden of accountability proportional to authority.'
}];
export function NCJISection() {
  return <section className="py-24 md:py-32 bg-cognarch-black relative border-t border-cognarch-border overflow-hidden" data-id="element-139">
      {/* Subtle technical background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-140">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:2rem_2rem]" data-id="element-141" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-142">
        <FadeIn data-id="element-143">
          <div className="mb-20" data-id="element-144">
            <div className="inline-flex items-center gap-4 mb-6" data-id="element-145">
              <div className="w-8 h-px bg-white/40" data-id="element-146" />
              <span className="text-white/60 tracking-widest uppercase text-sm font-medium" data-id="element-147">
                The Framework
              </span>
            </div>
            <h2 className="text-4xl md:text-6xl font-serif mb-6 tracking-tight text-white" data-id="element-148">
              NCJI
            </h2>
            <p className="text-xl md:text-2xl font-serif text-white/50 max-w-3xl" data-id="element-149">
              The Neurocognitive Civic Judgment Index: The system for measuring
              and developing civic judgment.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-150">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <FadeIn key={index} delay={0.05 * index} data-id="element-151">
                <div className="group bg-white/5 border border-white/10 p-6 hover:bg-white/10 transition-all duration-300 h-full flex flex-col relative overflow-hidden" data-id="element-152">
                  {/* Dashboard-like accent */}
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-white/0 group-hover:bg-white/30 transition-colors duration-300" data-id="element-153" />

                  <div className="flex items-center justify-between mb-6" data-id="element-154">
                    <div className="p-3 bg-white/5 rounded-sm border border-white/10 group-hover:border-white/20 transition-colors" data-id="element-155">
                      <Icon className="w-6 h-6 text-white/70" strokeWidth={1.5} data-id="element-156" />
                    </div>
                    <span className="text-xs font-mono text-white/20 group-hover:text-white/40 transition-colors duration-300" data-id="element-157">
                      IDX.{String(index + 1).padStart(2, '0')}
                    </span>
                  </div>

                  <h3 className="text-lg font-medium text-white mb-3 group-hover:text-white transition-colors" data-id="element-158">
                    {feature.title}
                  </h3>

                  <p className="text-sm text-white/40 leading-relaxed mt-auto" data-id="element-159">
                    {feature.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}